<template>
	<div>
		<div class="title">
			<el-row style="margin: 0 0 10px 0 ;">
				<el-col :lg="22">
					<div class="waiTitel">
						<div class="green01"></div>
						<div class="title"
							style="margin: 0 0 0 3px; font-family: SourceHanSansCN-Bold; font-size: 18px;">订单业绩列表</div>
					</div>
				</el-col>
				<el-col :lg="2">
					<el-button @click="getOrders()" size="small" icon="el-icon-refresh"
						style="margin-left: 10px;background-color: #ffffff; color: #000000; float: right;">刷新
					</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="tableCol">
			<p>
				<el-select v-model="query.type" style="width: 130px;" size="small">
					<el-option v-for="item in keys" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" style="width: 150px;margin-right: 10px;" size="small" v-model="query.text">
				</el-input>
				门店
				<el-select v-model="query.storeId" clearable filterable
					style="width: 150px;margin-left: 10px;margin-right: 10px;" size="small">
					<el-option-group label="营业门店" class="store">
						<el-option v-for="item in stores" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
					<el-option-group label="结业门店">
						<el-option v-for="item in storesEnd" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
				</el-select>
				状态
				<el-select v-model="query.orderStatus" collapse-tags
					style="width: 150px;margin-left: 10px;margin-right: 10px;" size="small">
					<el-option v-for="item in orderStateList" :key="item.value" :label="item.label" :value="item.value"
						:disabled="query.orderStatus[0] == 100 && item.value != 100">
					</el-option>
				</el-select>
				类型
				<el-select v-model="query.orderType" style="width: 150px;margin-left: 10px;margin-right: 10px;"
					size="small">
					<el-option v-for="item in orderTypeList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-select v-model="query.timeType" style="width: 150px;" size="small">
					<el-option key="0" label="提交时间" value="0">提交时间</el-option>
					<el-option key="1" label="付款时间" value="1">付款时间</el-option>
				</el-select>
<!--				<el-date-picker v-model="query.time" type="daterange" size="small"-->
<!--					style="margin-right: 25px; width: 250px;" value-format="yyyy-MM-dd" range-separator="至">-->
<!--				</el-date-picker>-->
        <el-date-picker
          v-model="query.time"
          type="daterange"
          size="small"
          style="margin-right: 25px; width: 250px;"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
				<span style="float: right; ">
					<el-button size="small" class="buttonStyle01" @click="query.page = 1, getOrders()">筛选
					</el-button>
					<el-button size="small" class="buttonStyle" @click="reload()">重置</el-button>
					<el-button size="small" class="buttonStyle" @click="expor()" style="margin-left: 20px;">导出订单业绩
					</el-button>
				</span>
			</p>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-table :data="orders" v-loading="loading"
					:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
					style="width: 100%">
					<el-table-column prop="id" align="center" label="ID" width="70px"></el-table-column>
					<el-table-column label="商品服务" align="center" width="80">
						<template slot-scope="scope">
							{{ scope.row.type == null ? '/' : scope.row.type }}
						</template>
					</el-table-column>
					<el-table-column prop="orderType" align="center" label="订单类型" width="110">
						<template slot-scope="scope">
							{{ scope.row.orderType | typeFormat }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="storeName" label="服务门店" width="100">
						<template slot-scope="scope">
							{{ scope.row.storeName ? scope.row.storeName : '无' }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="workerName" label="发型师" width="65">
						<template slot-scope="scope">
							{{ scope.row.workerName ? scope.row.workerName : '无' }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="total" label="服务价格" width="85">
						<template slot-scope="scope">
							{{ scope.row.total == null ? scope.row.payTotal == null ? '0' :
									scope.row.payTotal.toFixed(2)
									: scope.row.total.toFixed(2)
							}}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="payTotal" label="支付总额" width="85">
						<template slot-scope="scope">
							{{ scope.row.payTotal == null ? '0' : scope.row.payTotal.toFixed(2) }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="couponTitle" label="优惠劵" width="100">
						<template slot-scope="scope">
							{{ scope.row.couponTitle ? scope.row.couponTitle : '/' }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="couponTitle" label="美团劵" width="70px">
						<template slot-scope="scope">
							{{ scope.row.youzanCode ? scope.row.youzanCode : '/' }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="addTime" label="添加时间" width="100">
					</el-table-column>
					<el-table-column align="center" prop="payTime" label="支付时间" width="100">
						<template slot-scope="scope">
							{{ scope.row.payTime ? scope.row.payTime : '/' }}
						</template>
					</el-table-column>
					<el-table-column align="center" label="业绩">
						<template slot-scope="scope">
							{{ scope.row.amount/100 }}
						</template>
					</el-table-column>
					<el-table-column align="center" label="业绩类型" width="100">
						<template slot-scope="scope">
							{{scope.row.ctype | ctypeFormat }}
						</template>
					</el-table-column>
					<el-table-column align="center" label="业绩计算" width="100">
						<template slot-scope="scope">
							{{ scope.row.commissionType | commissionTypeFormat }}
						</template>
					</el-table-column>
					<el-table-column align="center" label="状态" width="80" fixed="right">
						<template slot-scope="scope">
							{{ statusRemark(scope.row.status) }}
						</template>
					</el-table-column>
				</el-table>
				<div style="text-align: center;">
					<el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
						style="margin-top: 30px;" layout=" total, prev, pager, next, jumper" :current-page="query.page"
						:total="query.total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Q from 'q';
	import {
		url,
		formatMoney
	} from '../../../utils/index.js'
	import {
		download,
		downloadFile
	} from '../../../excel/download';
	import requestDefault from '../../../excel/download';
	export default {
		data() {
			return {
				loading: false,
				url: url(),
				query: {
					page: 1,
					size: 10,
					total: null,
					type: 4,
					text: "",
					addTime: null,
					orderStatus: [],
					orderType: [],
					payType: "",
					timeType: '0',
					time: [new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date()
							.getMonth() + 1) : (new Date().getMonth() + 1)) + '-' + ((new Date().getDate()) < 10 ?
							'0' + (new Date()
								.getDate()) : new Date().getDate()) + ' 00:00:00',
						new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date()
							.getMonth() + 1) : (new Date().getMonth() + 1)) + '-' + ((new Date().getDate()) < 10 ?
							'0' + (new Date()
								.getDate()) : new Date().getDate()) + ' 23:59:59'
					],
					storeId: '',
				},
				keys: [{
					label: "发型师名称",
					value: 4,
				}, {
					label: "剪发订单ID",
					value: 0,
				}, {
					label: "用户昵称/手机号",
					value: 3,
				}, {
					label: "商品名称",
					value: 2,
				}, ],
				orderStateList: [{
					label: "全部",
					value: 100,
				}, {
					label: "排队中",
					value: 0,
				}, {
					label: "服务中",
					value: 1,
				}, {
					label: "待付款",
					value: 2,
				}, {
					label: "已支付",
					value: 3,
				}, {
					label: "已完成",
					value: 5,
				}, {
					label: "已取消",
					value: -1,
				}, {
					label: "售后订单",
					value: -2,
				}, {
					label: "支付中",
					value: 21,
				}, ],
				orderTypeList: [{
					label: "全部",
					value: "",
				}, {
					label: "普通订单",
					value: "1",
				}, {
					label: "美团订单",
					value: "9",
				}, {
					label: "权益订单",
					value: "11",
        }, {
          label: "卡金充值",
          value: "14",
				}],
				orders: [],
				stores: [], //营业门店
				storesEnd: [], //全部门店
			};
		},
		computed: {
			statusRemark() {
				return (val) => {
					let result = '';
					this.orderStateList.forEach(ele => {
						if (ele.value == val) result = ele.label;
					});
					return result;
				}
			},
		},
		filters: {
			typeFormat(val) {
				switch (val) {
					case "1":
						return "普通订单";
					case "3":
						return "次卡订单";
					case "10":
						return "染发次卡订单";
					case "5":
						return "膨胀券订单";
					case "6":
						return "会员订单";
					case "7":
						return "会员续费订单";
					case "9":
						return "美团订单";
					case "2":
						return "企业剪订单";
					case "11":
						return "权益订单";
          case "14":
            return "卡金充值";
					default:
						return "/";
				}
			},
			ctypeFormat(val) {
				switch (val) {
					case "0":
						return "剪发";
					case "1":
						return "评价提成";
					case "2":
						return "会员提成";
					case "3":
						return "会员业绩";
					case "4":
						return "抖音双倍";
          case "5":
            return "卡金提成";
          case "6":
            return "卡金业绩";
					default:
						return "/";
				}
			},
			commissionTypeFormat(val) {
				switch (val) {
					case "0":
						return "常规";
					case "1":
						return "实收";
					default:
						return "/";
				}
			}
		},
		mounted() {
			this.getStores();
			this.getOrders();
		},
		methods: {
			// 重置
			reload() {
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					type: 4,
					text: "",
					addTime: null,
					orderStatus: [],
					orderType: "",
					payType: "",
					timeType: '0',
					time: [new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date()
							.getMonth() + 1) : (new Date().getMonth() + 1)) + '-' + ((new Date().getDate()) < 10 ?
							'0' + (new Date()
								.getDate()) : new Date().getDate()),
						new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date()
							.getMonth() + 1) : (new Date().getMonth() + 1)) + '-' + ((new Date().getDate()) < 10 ?
							'0' + (new Date()
								.getDate()) : new Date().getDate())
					],
				};
				this.getOrders()
			},
			handleCurrentChange(val) {
				this.query.page = val;
				if (this.query.time != null ) {
					this.getOrders()
				} else {
					this.getOrders(1)
				}

			},
			handleSizeChange(val) {
				this.query.size = val;
				if (this.query.time != null ) {
					this.getOrders()
				} else {
					this.getOrders(1)
				}
			},
			expor() {
				if (this.query.time != null) {
					let a = this.requestData()
					// var parm = this.toString(a)
					requestDefault({
						method: 'post',
						url: 'dOrderCommission/exporOrderCommission',
						data:a,
						headers:{
							'Content_Type':"application/json"
						},
						responseType: 'blob'
					}).then(res => {
						console.log(res)
						downloadFile(res.data, '业绩列表', 'xlsx')
					})
					// window.location.assign(this.url + "dOrderCommission/exporOrderCommission" + parm)
				} else {
					this.$message.error("请设置时间范围再导出")
				}
			},
			//将参数转为字符串
			toString(a) {
				var result = '?page=' + a.page + '&size=' + a.size
				if (a.type != undefined) {
					result += '&type=' + a.type
				}
				if (a.text != undefined) {
					result += '&text=' + a.text
				}
				if (a.startTime != undefined) {
					result += '&startTime=' + a.startTime
				}
				if (a.endTime != undefined) {
					result += '&endTime=' + a.endTime
				}
				if (a.orderStatus != undefined && a.orderStatus != "") {
					result += '&orderStatus=' + a.orderStatus
				}
				if (a.orderType != undefined) {
					result += '&orderType=' + a.orderType
				}
				if (a.storeId != undefined) {
					result += '&storeId=' + a.storeId
				}
				if (a.timeType != undefined) {
					result += '&timeType=' + a.timeType
				}
				return result
			},
			//获取参数
			requestData(t) {
				var arr = {
					page: this.query.page,
					size: this.query.size,
				}
				if (this.query.time) {
					arr.timeType = this.query.timeType
					arr.startTime = this.query.time[0]
					arr.endTime = this.query.time[1]
				}
				if (this.query.orderStatus != null && this.query.orderStatus != 100) {
					arr.orderStatus = this.query.orderStatus
				}
				if (this.query.orderType != '') {
					arr.orderType = this.query.orderType
				}
				if (this.query.storeId != '') {
					arr.storeId = this.query.storeId
				}
				if (this.query.text != '') {
					arr.type = this.query.type
					arr.text = this.query.text
				}
				// if (this.query.text != ''  && this.query.time != null) {
				// 	delete arr.timeType
				// 	delete arr.startTime
				// 	delete arr.endTime
				// }
				return arr;
			},
			//业绩列表
			getOrders(type) {
				this.loading = true;
				let t = setTimeout(() => { //15秒超时
					this.loading = false
					this.$message.error("请求失败")
				}, 15000)
				var a;
				a = this.requestData()
				this.$http.get("dOrderCommission/orderCommissionList", {
					params: a
				}, {
					emulateJSON: true
				}).then(res => {
					if (res.data.code == 200) {
						this.orders = res.body.data.rows;
						this.query.total = res.body.data.total;
					} else {
						this.$message.error(res.data.msg);
					}
					this.loading = false
					clearTimeout(t)
				})
			},
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType === 1) {
							this.storesEnd.push(ele) //结业门店
						} else {
							this.stores.push(ele) //营业门店
						}
					})
				})
			},
		},
	};
</script>


<style lang="less" scoped>
	.tableCol {
		border-radius: 4px;
		box-shadow: 2px 2px 3px 2px rgba(102, 102, 102, 0.5);
		margin: 30px -3px 0px -3px;
		padding: 5px 15px 30px 15px;
	}

	.waiTitel {
		display: flex;
		border-radius: 2px;
	}

	.green01 {
		height: 14px;
		width: 5px;
		background-color: #4AB52E;
		margin: 5px 0 0 0
	}

	.green02 {
		width: 5px;
		height: 5px;
		background: #4AB52E;
		margin: 15px 5px 0 5px
	}

	.buttonStyle {
		// margin-right: 10px;
		font-family: SourceHanSansCN-Bold;
		background: #FFFFFF !important;
		border-radius: 5px;
		border: 1px solid #CBC9C9;
	}

	.buttonStyle01 {
		margin-right: 10px;
		font-family: SourceHanSansCN-Bold;
		color: #FFFFFF;
		background: #4AB52E !important;
		border-radius: 5px;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #4AB52E;
		border-radius: 5px;
		color: #FFF;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #4AB52E;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled) {
		border-radius: 5px;
	}

	/deep/.el-icon-arrow-down:before {
		content: "\e6d1";

	}
	/deep/.el-select-dropdown__item {
		width:220px;
	}
</style>
